import { useUserSession } from "features/session/context";
import { useMemo } from "react";
import { safeParseDate } from "shared/util";

export const useUpdateTime = (updateTime: string | null | undefined) => {
	const { isDemo } = useUserSession()
	return useMemo(
		() => {
			const time = safeParseDate(updateTime)?.getTime()
			if (!time) return undefined
			return isDemo ? `demo_${time}` : `${time}`
		},
		[updateTime, isDemo]
	)
}

export type InsiteModelResult = {
  createTime: string
  updateTime: string
  updateUserId: number | null
  updateUserName: string | null
}